<template>
  <div id="app">
  <div class="center">
    <router-view/>
  </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    centerScroll () {
      const app = document.getElementById('app')
      const appWidth = app.offsetWidth // 获取容器的宽度
      const windowWidth = window.innerWidth // 获取窗口的宽度

      // 如果窗口宽度小于容器宽度，计算滚动条位置
      if (windowWidth < appWidth) {
        const scrollLeft = (appWidth - windowWidth) / 2 // 计算中间位置
        window.scrollTo({
          left: scrollLeft, // 滚动到中间位置
          behavior: 'auto' // 滚动行为（auto 或 smooth）
        })
      }
    }
  },
  mounted () {
    // 页面加载时调用一次
    this.centerScroll()

    // 监听窗口大小变化
    window.addEventListener('resize', this.centerScroll)
  },
  beforeDestroy () {
    // 组件销毁时移除事件监听
    window.removeEventListener('resize', this.centerScroll)
  }
}
</script>

<style lang="less" scoped>
#app {
  color: black;
  min-width: 1200px; /* 设置最小宽度 */
  display: flex;
  align-items: center;
  justify-content: center;
}

.center {
  width: 100%;
  height: 100%;
  text-align: center; /* 内容居中 */
}
</style>
